export default __webpack_public_path__ + "static/media/Group_16955.5ff26d3c.svg";